import {http} from '@/helpers/http-helper';

class Note {
    constructor(user, note, date) {
        this.user = user;
        this.note = note;
        this.date = date;
    }
}

export const getClientNotes = (memberUuid) => {
    return new Promise( (resolve, reject) => {

        const url = 'clients/' + memberUuid + '/notes';

        http.get(url)
            .then((response) => {

                if (response.status === 200) {

                    let notes = [];

                    response.data.forEach((note) => {
                        notes.push(new Note(note.user, note.note, new Date(note.date)));
                    });

                    resolve(notes);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createClientNote = (memberUuid, note) => {
    return new Promise( (resolve, reject) => {

        const url = 'clients/' + memberUuid + '/note';

        http.post(url, {note})
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};